import { GetTelemetryHistoryResponse } from '@eppendorf/vnls-device-service-utils';
import { addDays, startOfDay } from 'date-fns';

export function shouldPadHistoryData(from?: number | null, to?: number | null): boolean {
  return from != null && to != null;
}

export function padHistoryDataToEndOfDay(
  data: GetTelemetryHistoryResponse,
): GetTelemetryHistoryResponse {
  const { historyData } = data;
  const lastBucket = historyData.at(-1);

  if (!lastBucket) {
    return data;
  }

  const lastBucketDate = new Date(lastBucket.timestamp);
  const nextMidnight = startOfDay(addDays(lastBucketDate, 1));

  const isAlreadyMidnight =
    lastBucketDate.getTime() === startOfDay(lastBucketDate).getTime();

  if (isAlreadyMidnight) {
    return data;
  }

  const paddedPoint = {
    ...lastBucket,
    timestamp: nextMidnight.getTime(),
    date: nextMidnight.toISOString(),
  };

  return {
    ...data,
    historyData: [...historyData, paddedPoint],
  };
}
